export const workspaceNameSlug = (workspaceName) =>
  String(workspaceName || "workspace")
    .toLowerCase()
    .replace(/['’‘]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 60)
    .replace(/-$/g, "") || "workspace";
